import React from 'react';

const RemoveCircleBold = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    id="Remove-Circle-Bold-Alternate--Streamline-Ultimate"
    height="24"
    width="24"
  >
    <desc>
      Remove Circle Bold Alternate Streamline Icon: https://streamlinehq.com
    </desc>
    <g>
      <path
        d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm0 21a9 9 0 1 1 9 -9 9 9 0 0 1 -9 9Z"
        fill="#000000"
        strokeWidth="1"
      />
      <path
        d="m17 7.76 -0.71 -0.71a1 1 0 0 0 -1.41 0l-2.7 2.65a0.25 0.25 0 0 1 -0.36 0L9.17 7.05a1 1 0 0 0 -1.41 0l-0.71 0.71a1 1 0 0 0 0 1.41l2.65 2.65a0.25 0.25 0 0 1 0 0.36l-2.65 2.65a1 1 0 0 0 0 1.41l0.71 0.71a1 1 0 0 0 1.41 0l2.65 -2.65a0.25 0.25 0 0 1 0.36 0l2.65 2.7a1 1 0 0 0 1.41 0l0.71 -0.71a1 1 0 0 0 0 -1.41l-2.65 -2.7a0.25 0.25 0 0 1 0 -0.36L17 9.17a1 1 0 0 0 0 -1.41Z"
        fill="#000000"
        strokeWidth="1"
      />
    </g>
  </svg>
);

export default RemoveCircleBold;
